<mat-dialog-content>
    <mat-icon>help_outline</mat-icon>
    <span>{{ 'You_have_pending_changes_warning' | translate }}</span>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button
          mat-dialog-close>
    {{ 'Cancel' | translate }}
  </button>
  <button mat-raised-button
          (click)="onConfirmClicked(2)"
          color="warn">
    {{ 'Discard_changes' | translate }}
  </button>
  <button mat-raised-button
          (click)="onConfirmClicked(1)"
          color="accent">
    {{ 'Save' | translate }}
  </button>
</mat-dialog-actions>
